// const env = require("../env");
// import Cookies from "js-cookie";

export const secretKey = "4028812a65faf4690165ffdcbfb71dc0";
export const version = "v1.0.0";
export const appVersion = "v1.0.0";

export const ywServer = "https://newapp.evcoming.com/sharego";

export const wechat_login = "http://zuul2.evcoming.com";
// env.getConfig(Cookies.get('xlg-front-env') || "prod").wechatAuth

export const jsApiList = [
  "openLocation",
  "getLocation",
  "hideOptionMenu",
  "showMenuItems",
  "hideMenuItems",
  "closeWindow",
  "onMenuShareTimeline",
  "onMenuShareAppMessage",
  "scanQRCode",
  "chooseWXPay",
  "hideAllNonBaseMenuItem",
  "chooseImage",
  "uploadImage",
  "updateTimelineShareData",
  "updateAppMessageShareData"
];